var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-feedback-screen',{attrs:{"animated":false,"transparent":""}},[_c('img',{staticClass:"mt-2 mb-3",attrs:{"src":_vm.img,"alt":_vm.alternativeImgText}}),(_vm.text)?_c('p',{staticClass:"t1 -mt_3 -mb_0 -mb_0 -px_2 center-text",class:{ '-t_medium fc-ctx-1': _vm.bold, 'fc-ctx-4': !_vm.bold }},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }